/**
 * Componente para mostrar la prioridad con su color configurado
 * 
 * Referencia: sistema-tickets-frontend-COMPLETO.md Sección 2.2
 */

import React from 'react';
import { Chip, Box } from '@mui/material';

/**
 * Componente PrioridadChip
 * 
 * @param {Object} props
 * @param {Object|null} props.prioridad - Objeto con nombre y color de la prioridad
 * @param {string} props.prioridad.nombre - Nombre de la prioridad
 * @param {string} props.prioridad.color - Color hexadecimal de la prioridad
 * @param {string} props.fontSize - Tamaño de fuente opcional (ej: '1.0806rem')
 * @returns {JSX.Element}
 */
const PrioridadChip = ({ prioridad, fontSize }) => {
  // Manejar caso cuando prioridad es null o undefined
  if (!prioridad) {
    return <Chip label="N/A" size="small" sx={fontSize ? { fontSize } : {}} />;
  }
  
  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      {/* Punto de color indicador */}
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: prioridad.color || '#757575'
        }}
      />
      {/* Chip con nombre de prioridad */}
      <Chip
        label={prioridad.nombre}
        size="small"
        sx={{
          bgcolor: `${prioridad.color || '#757575'}20`, // Color con 20% de opacidad
          color: prioridad.color || '#757575',
          fontWeight: 'bold',
          ...(fontSize && { fontSize }) // ✅ Aplicar fontSize si se proporciona
        }}
      />
    </Box>
  );
};

export default PrioridadChip;

